import { Box, Card, Divider, Theme, Typography } from "@mui/material";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { HeadingLevel } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

const styles = (theme: Theme) => ({
  content: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  subtitle: {
    color: theme.palette.grey.A400,
  },
  circle: {
    minWidth: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: theme.palette.success.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.25),
    color: "white",
  },
  divider: {
    borderColor: theme.palette.secondary.light,
  },
});

const StepContent = ({ currentStep }: { currentStep: number }) => {
  const classes: any = useCustomStyles(styles);

  return (
    <>
      <Box sx={classes?.circle}>
        <Typography variant={HeadingLevel.Subtitle1}>{currentStep}</Typography>
      </Box>
      <Box width="100%">
        <Box sx={classes?.content}>
          <Typography variant={HeadingLevel.Subtitle1}>
            {t(`nextsteps.step${currentStep}.title`)}
          </Typography>
          <Typography sx={classes?.subtitle} variant={HeadingLevel.Body2}>
            {t(`nextsteps.step${currentStep}.subtitle`)}
          </Typography>
        </Box>
        <Typography variant={HeadingLevel.Body2}>
          {t(`nextsteps.step${currentStep}.content`)}
        </Typography>
      </Box>
    </>
  );
};

const NextStepSummaryComponent = () => {
  const classes: any = useCustomStyles(styles);
  const NEXT_STEPS_COUNT: number = parseInt(t(`nextsteps.count`));

  return (
    <Card sx={{ boxShadow: "none" }}>
      {[...Array(NEXT_STEPS_COUNT)].map((_, index) => (
        <Box key={index}>
          <Box display="flex" p={2}>
            <StepContent currentStep={index + 1} />
          </Box>
          {index !== NEXT_STEPS_COUNT - 1 && <Divider sx={classes?.divider} />}
        </Box>
      ))}
    </Card>
  );
};
export default NextStepSummaryComponent;
